const DEVICE_ID_KEY = 'vs.deviceId';
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

let sessionId: string | null = null;

/**
 * Random identifier of this browser, sent with each live action so the server
 * can tell two tablets apart on the same match (VOL-14). Not tied to the
 * account: a tablet shared within a club stays one device.
 */
export function getDeviceId(): string {
  try {
    const stored = localStorage.getItem(DEVICE_ID_KEY);
    if (stored && UUID_PATTERN.test(stored)) return stored;
    const id = sessionId ?? crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, id);
    sessionId = id;
    return id;
  } catch {
    // Storage refused: one id for this page load still tells this device apart.
    sessionId ??= crypto.randomUUID();
    return sessionId;
  }
}

/** Test-only reset of the id kept for this page load. */
export function __resetDeviceId(): void {
  sessionId = null;
}
